export const favoriteTitle = 'Избранные'
export const lastListenedTitle = 'Недавно прослушанные'
export const popularTitle = 'Популярное'
